import InfluencerAnalyticsHome from '../components/InfluencerAnalyticsHome';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../consts';

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('selectedTab', 'updateSelectedTab', 0),
  withHandlers({
    onChangeTab: props => (evt, value) => {
      props.updateSelectedTab(value);
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.INFLUENCER);
    },
    componentDidMount() {},
  })
);

export default enhance(InfluencerAnalyticsHome);
